import {
  IRowPattern,
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
  TIContainerInformationExtendedValid,
  sortRowsArray,
} from "@tedivo/tedivo-bay-grid-pure";

import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";

/** Returns all containers, sorted from Port to Stbd */
export function getAllContainersStbdSide(
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
): TGetContainersFilterOutput {
  const { allStacksKeys } = smartBay.getGridContent();

  // Sorts from Port to Starboard. Therefore, the last containers drawn will be the ones on the starboard side, which is what we want to show in the side view of STBD.
  const allStackKeysSortd = allStacksKeys.slice().sort(sortRowsArray);

  return getAllContainers(smartBay, allStackKeysSortd);
}

export function getAllContainersPortSide(
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
): TGetContainersFilterOutput {
  const { allStacksKeys } = smartBay.getGridContent();

  // Sorts from Starboard to Port. Therefore, the last containers drawn will be the ones on the Port side, which is what we want to show in the side view of PORT.
  const allStackKeysSortd = allStacksKeys.slice().sort(sortRowsArray).reverse();

  return getAllContainers(smartBay, allStackKeysSortd);
}

function getAllContainers(
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
  allStackKeysSortd: IRowPattern[],
): TGetContainersFilterOutput {
  const containers: TIContainerInformationExtendedValid[] = [];
  const { gridContent, allTiersKeys } = smartBay.getGridContent();

  for (const tierKey of allTiersKeys) {
    for (const stackKey of allStackKeysSortd) {
      const currContent = gridContent[stackKey]?.[tierKey];

      if (!currContent) continue;

      containers.push(...(currContent.containers as TIContainerInformationExtendedValid[]));
    }
  }

  return {
    containers,
    tBaysStr: smartBay.tBaysStr,
    level: smartBay.level,
  };
}
